/**
 * @owner @Appboy/whats-app
 * WhatsApp Carousel Response Schema
 *
 * Shared schema for the carousel-layout response message's "carousel" field.
 */

import { z } from "zod";
import { whatsAppResponseCarouselCardSchema } from "@schemas/message/whatsAppResponseCarouselCardSchema";

// Both fields required (matches WhatsAppResponseMessageCarouselExport["carousel"]): a carousel
// always needs a button type and at least 2 cards (see Carousel#content_validations).
export const whatsAppResponseCarouselSchema = z.object({
  // Only "quick-reply" and "url" are supported for carousel response messages, unlike the
  // template builder's carousel (see Carousel::VALID_BUTTON_TYPES).
  carousel_button_type: z.enum(["quick-reply", "url"]),
  cards: z.array(whatsAppResponseCarouselCardSchema),
});
